import apiClient, { extractData } from '../api-client';

// API công khai (không cần đăng nhập) — xác thực bằng token trong query.
export const publicApi = {
  // Danh sách đơn ĐANG SẢN XUẤT cho bảng QR xưởng (thợ may quét xem).
  getProductionBoard(token) {
    return apiClient
      .get('/public/production-board', { params: { t: token } })
      .then(extractData);
  },

  // Snapshot realtime cho màn hình TV treo ở xưởng (doanh thu/đơn/BXH/tiến độ).
  getTvDashboard(token, theme = 'dark') {
    return apiClient
      .get('/public/tv-dashboard', { params: { t: token, theme } })
      .then(extractData);
  },
};
